module.exports = __webpack_public_path__ + "img/logo-w.22e5a43b.png";